import { useRef, useState } from 'react';
import { toast } from 'sonner';
import { Camera, X } from 'lucide-react';
import { api } from '../lib/api';
import { imgSrc } from '../lib/cart';

export function ImageField({ value, onChange, label, testid, className }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append('file', f);
      const { data } = await api.post('/uploads/shop-image', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      onChange(data.url); toast.success(`${label} envoyé`);
    } catch (err) { toast.error(err?.response?.data?.detail || "Échec de l'envoi"); }
    finally { setBusy(false); if (ref.current) ref.current.value = ''; }
  };
  return (
    <div data-testid={testid} className={`relative rounded-xl overflow-hidden border-2 border-dashed border-slate-600 bg-slate-900/60 ${className}`}>
      {value && <img src={imgSrc(value)} alt="" className="absolute inset-0 h-full w-full object-cover" />}
      {value && <button type="button" data-testid={`${testid}-remove`} onClick={() => onChange('')} className="absolute top-1 right-1 h-6 w-6 grid place-items-center rounded-full bg-black/70 text-white z-10"><X className="h-3 w-3" /></button>}
      <label className={`absolute inset-0 grid place-items-center cursor-pointer text-xs text-center ${value ? 'bg-black/40 opacity-0 hover:opacity-100 text-white' : 'text-slate-400 hover:text-sky-300'} transition-opacity`}>
        <div><Camera className="h-5 w-5 mx-auto mb-1" />{busy ? 'Envoi…' : value ? 'Changer' : label}</div>
        <input ref={ref} type="file" accept="image/*,.heic,.heif" className="hidden" onChange={upload} disabled={busy} data-testid={`${testid}-input`} />
      </label>
    </div>
  );
}
